"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthenticatedUserService = void 0;
const service_1 = require("@phishtool/service");
const contact_request_1 = require("~server/controllers/service/users/contact-request");
const _middleware_1 = require("~middleware");
class UnauthenticatedUserService extends service_1.Service {
    constructor() {
        super(...arguments);
        this.useSendContactRequest = this.addSingletonNonResourceMutation({
            controller: contact_request_1.loggedOutContactRequestHandler,
            schema: contact_request_1.LoggedOutContactRequestDataSchema,
            middleware: [_middleware_1.recaptchaMiddleware, _middleware_1.rateLimitMiddleware],
            routeId: 'contact-request',
        });
    }
}
exports.UnauthenticatedUserService = UnauthenticatedUserService;
